module.exports = __webpack_public_path__ + "media/brands/zaz-9b57e8d4.png";